export const INITIALISE_BROADCAST_API_LISTENER =
    "INITIALISE_BROADCAST_API_LISTENER";

export function initialiseBroadcastAPIListener() {
    return {
        type: INITIALISE_BROADCAST_API_LISTENER,
    };
}
